import { on } from '@ember/modifier';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import ActionItemTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/action-item-template';
import PageTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/page-template';
import type StatsigService from 'garaje/services/statsig';

import type { KioskDemoPage } from '../provider';

export default class FinalScreen extends Component<KioskDemoPage> {
  @service declare router: RouterService;
  @service declare statsig: StatsigService;

  @action async onPairClick(): Promise<void> {
    if (this.args.isUserLoggedIn && !this.args.isDemoInstance) {
      this.statsig.logEvent(`kiosk-demo-${this.args.demoName}-pair-ipad-clicked`);
    }
    await this.router.transitionTo('visitors.devices.ipads').catch();
  }

  @action async onQRClick(): Promise<void> {
    if (this.args.isUserLoggedIn && !this.args.isDemoInstance) {
      this.statsig.logEvent(`kiosk-demo-${this.args.demoName}-qr-code-clicked`);
    }
    await this.router.transitionTo('visitors.settings.welcome-screen.touchless-walkins').catch();
  }

  <template>
    <PageTemplate
      @headerTitle="Final Screen"
      @headerInfo="That’s it! To test the full visitors experience with your own settings, pair an iPad or set up mobile sign in by creating a static QR code."
      @currentStep={{@currentStep}}
      @totalStepCount={{@totalStepCount}}
      @demoName={{@demoName}}
      @isUserLoggedIn={{@isUserLoggedIn}}
      @isDemoInstance={{@isDemoInstance}}
    >
      <div>
        {{#if @isUserLoggedIn}}
          <div>
            <div class="mb-4">Test it yourself:</div>
            <div class="flex items-center gap-4">
              <button class="btn btn--brand" {{on "click" this.onPairClick}} data-test-kiosk-demo-pair-ipad>Pair iPad</button>
              <button class="btn btn--outline" {{on "click" this.onQRClick}} data-test-kiosk-demo-qr-code>Set up mobile
                sign in</button>
            </div>
          </div>
        {{else}}
          <div data-test-kiosk-demo-last-page-links>
            <ActionItemTemplate
              @header="Pair iPad"
              @headerInfo="Set up a kiosk on your front desk."
              @subHeader="Available on all plans"
              @iconLink="/assets/images/ipad-demo/icons/ipad.svg"
              @iconAlt="Image of iPad"
              @pageLink="/visitors/devices/ipads"
              @isUserLoggedIn={{@isUserLoggedIn}}
              @demoName={{@demoName}}
              @isDemoInstance={{@isDemoInstance}}
            />
            <ActionItemTemplate
              @header="Static QR code"
              @headerInfo="Enable visitors to sign in via mobile by scanning a QR code."
              @subHeader="Required plan: Premium"
              @iconLink="/assets/images/ipad-demo/icons/qr-code.svg"
              @iconAlt="Image of sign in flow"
              @pageLink="/visitors/settings/welcome-screen/touchless-walkins"
              @isUserLoggedIn={{@isUserLoggedIn}}
              @demoName={{@demoName}}
              @isDemoInstance={{@isDemoInstance}}
            />
          </div>
        {{/if}}
      </div>
    </PageTemplate>
  </template>
}
